import type { ClientType, CustomerBehaviorProfile, FoodCategory, Market } from '../types';

export const APP_NAME = 'Venda de Valor CVale Alimentos';
export const APP_SUBTITLE = 'FCC - Formação Comercial CVale - Valor do Campo ao Cliente';

export const PROFILE_LABELS: Record<CustomerBehaviorProfile, string> = {
  analitico: 'Analítico',
  diretivo: 'Diretivo',
  integrador: 'Integrador',
  expressivo: 'Expressivo'
};

export const CATEGORY_LABELS: Record<FoodCategory, string> = {
  aves: 'Aves',
  embutidos: 'Embutidos',
  industrializados: 'Industrializados',
  pescados: 'Pescados'
};

export const MARKET_LABELS: Record<Market, string> = {
  interno: 'Mercado interno',
  externo: 'Mercado externo'
};

export const CLIENT_TYPE_LABELS: Record<ClientType, string> = {
  varejo_independente: 'Varejo independente',
  supermercado_bairro: 'Supermercado de bairro',
  rede_regional: 'Rede regional',
  varejo_nacional: 'Varejo nacional',
  atacado_cash_carry: 'Atacado / cash and carry',
  distribuidor: 'Distribuidor',
  food_service: 'Food service',
  key_account: 'Key account',
  varejo_tradicional: 'Varejo tradicional',
  industria: 'Indústria',
  marca_propria: 'Marca própria',
  outro: 'Outro',
  distribuidor_importador: 'Distribuidor / importador',
  food_service_internacional: 'Food service internacional',
  varejo_internacional: 'Varejo internacional',
  industria_processadora: 'Indústria processadora',
  trading: 'Trading'
};

export const INTERNAL_CLIENT_OPTIONS: ClientType[] = [
  'varejo_independente',
  'supermercado_bairro',
  'rede_regional',
  'varejo_nacional',
  'atacado_cash_carry',
  'distribuidor',
  'food_service',
  'key_account',
  'varejo_tradicional',
  'industria',
  'marca_propria',
  'outro'
];

export const EXTERNAL_CLIENT_OPTIONS: ClientType[] = [
  'distribuidor_importador',
  'food_service_internacional',
  'varejo_internacional',
  'industria_processadora',
  'trading',
  'outro'
];

export const COMMERCIAL_TERMS = [
  'giro',
  'margem',
  'entrada de pedidos',
  'saída da categoria',
  'PPC',
  'PPV',
  'markup',
  'markdown',
  'margem em reais',
  'regularidade de fornecimento',
  'qualidade certificada',
  'exposição',
  'ruptura',
  'mix',
  'participação',
  'rentabilidade da categoria',
  'desenvolvimento de canal',
  'parceria comercial',
  'contrapartida',
  'diferenciação competitiva',
  'abastecimento',
  'previsibilidade',
  'visão de longo prazo'
];

export const CHANNEL_VALUE_DRIVERS: Record<ClientType, string[]> = {
  varejo_independente: ['giro com simplicidade operacional', 'mix rentável por espaço limitado', 'parceria comercial próxima'],
  supermercado_bairro: ['sortimento adequado ao bairro', 'abastecimento regular', 'saída da categoria por boa execução de ponta de gôndola'],
  rede_regional: ['rentabilidade da categoria por grupo de lojas', 'plano promocional com contrapartida', 'padronização de execução'],
  varejo_nacional: ['governança comercial', 'escala com previsibilidade', 'desempenho por categoria e participação'],
  atacado_cash_carry: ['velocidade de giro', 'competitividade controlada', 'volume com margem protegida'],
  distribuidor: ['capilaridade com regularidade', 'mix que acelera revenda', 'visão conjunta de entrada de pedidos e saída da categoria'],
  food_service: ['padronização operacional', 'regularidade de fornecimento', 'custo por uso e rendimento'],
  key_account: ['plano de crescimento conjunto', 'leitura por conta', 'contrapartidas claras e mensuráveis'],
  varejo_tradicional: ['abastecimento simples', 'combinação de giro e margem', 'suporte de execução no ponto de venda'],
  industria: ['continuidade operacional', 'especificação consistente', 'custo total de fornecimento'],
  marca_propria: ['confiabilidade', 'padrão de qualidade', 'visão de longo prazo com previsibilidade'],
  outro: ['leitura comercial da conta', 'rentabilidade sustentável', 'próximo passo com lógica de valor'],
  distribuidor_importador: ['previsibilidade de embarque', 'padrão e rastreabilidade', 'continuidade de fornecimento'],
  food_service_internacional: ['padronização', 'segurança alimentar', 'fornecimento confiável'],
  varejo_internacional: ['conformidade', 'qualidade certificada', 'estabilidade de mix e calendário'],
  industria_processadora: ['regularidade de matéria-prima', 'especificação estável', 'custo de troca de fornecedor'],
  trading: ['segurança de execução', 'previsibilidade documental', 'relação de longo prazo']
};

export const CATEGORY_VALUE_DRIVERS: Record<FoodCategory, string[]> = {
  aves: ['regularidade de abastecimento', 'padrão de qualidade', 'mix com bom giro e rentabilidade'],
  embutidos: ['valor agregado', 'exposição correta', 'mix que melhora margem da categoria'],
  industrializados: ['diferenciação competitiva', 'planejamento promocional com contrapartida', 'ganho de participação'],
  pescados: ['qualidade certificada', 'previsibilidade de fornecimento', 'redução de ruptura com mix assertivo']
};
